import { Component, OnInit } from "@angular/core";
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { log } from "console";
import { data } from "src/app/audit-trail/application/data";
import { AuditTrailService } from "src/app/audit-trail/audit-trail.service";
import { LotteryFormResponse } from "src/app/model/LotteryFormResponse";
import { ExportImportService } from "src/app/services/export-import.service";
import { PublishLettersService } from "src/app/services/publish-letters.service";
import { ReportService } from "src/app/services/report.service";

@Component({
  selector: "app-update-aadhar",
  templateUrl: "./update-adhar.component.html",
  styleUrls: ["./update-adhar.component.scss"],
})
export class UpdateAadharDetails implements OnInit {
  [x: string]: any;
  form: FormGroup = new FormGroup({});
  isLoading = false;
  lotteryList: {[key: number]: string};
  isSubmitDisabled: boolean = false;
  downloadedBatches: string[] = [];
  applicationNo: string = '';
  panData:any;
  aadharFrontSelectedFile:string | ArrayBuffer;
  aadharBackSelectedFile:string | ArrayBuffer;
  isAadharPhotoEnable:boolean = false;

  selectedFileFrontPhotoName: string = '';
  selectedFileBackPhotoName: string = '';

  remark: string;
  selectedAadharType: string;

  changedAadharFrontPhoto:string | ArrayBuffer;
  changedAadharBackPhoto:string | ArrayBuffer;
   
  constructor(
    private router: Router,
    private exportImportService: ExportImportService,
    private reportService:ReportService,
    private publishLetterService: PublishLettersService,
    private auditTrailService: AuditTrailService
    , private _snackBar: MatSnackBar
  ) {}

  ngOnInit(): void {
    this.loadData();
  }

  loadData() {
  
    this.changeAadharPhotoFile();
  
  }

 
  refresh() {
    this.loadData();
  }

  refresh1() {
    this.fetchSpousePanDetails()
    // window.location.reload();
  }

  async successToast(msg:any) {
    await this._snackBar.open(
        msg,
        "Close", {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "success-toast",
        duration: 3 * 1000,
        }
    );
}


async errorToast(msg:any) {
  await this._snackBar.open(
      msg,
      "Close", {
      horizontalPosition: "right",
      verticalPosition: "top",
      panelClass: "error-toast",
      duration: 3 * 1000,
      }
  );
}


aadharFrontPhoto:any;
aadharBackPhoto:any;
frontPhotoStatus: string;
backPhotoStatus:string;

fetchSelfAadharDetails() {
    console.log(this.applicationNo);
    this.isLoading = true;
    this.auditTrailService.fetchSelfAadharDetailsService({applicationNo:this.applicationNo})
    .subscribe((data) => {
       console.log(data,"=========>");
       this.aadharFrontPhoto = data.data;
       this.frontPhotoStatus = data.status;

      this.isLoading = false;
      this.panData = data;
      if(data.status === 'SUCCESS') {
      }
      else {
        this.errorToast(data.errorMessage); 
        this.isLoading = false;

      }
    }, error => {
      this.isLoading = false;
      this.exportImportService.errorToast("Please enter valid Application no.");
    });
 
}


fetchAadharBackPhoto() {
  console.log(this.applicationNo);
  this.isLoading = true;
  this.auditTrailService.fetchAadharBackPhotoService({applicationNo:this.applicationNo})
  .subscribe((data) => {
     console.log(data,"=========>");
     this.aadharBackPhoto = data.data;
     this.backPhotoStatus = data.status;
    if(data.status === 'SUCCESS') {
      this.isLoading = false;

    }
    else {
      this.errorToast(data.errorMessage); 
      this.isLoading = false;

    }
  }, error => {
    this.isLoading = false;
    this.exportImportService.errorToast("Please enter valid Application no.");
  });

}

changeAadharPhotoFile() {

  this.validateRemark();

  if (this.errorMessage) {
    return;
  }

  let payload: any ={
    applicationNo:this.applicationNo,
    changeAadharFrontPhoto:this.aadharFrontPhoto,
    changeAadharBackPhoto:this.aadharBackPhoto,
    applicantRemarks:this.remark,
    selectedAadharType: localStorage.getItem('selectedAadharType'),
  }
   console.log(">>>>>>>>>>>>>>>>>>>>>>>>>>>>",payload);

   
  // if (!this.uploadedFile) {
  //   this.errorMessage = 'Please select a file.';
  //   return;
  // }
  console.log(this.applicationNo);
  console.log("this.aadharFrontPhoto**BfrApiCall**", this.aadharFrontPhoto);
  console.log("this.aadharBackPhoto**BfrApiCall**", this.aadharBackPhoto);

  this.isLoading = true;
  this.auditTrailService.changeAadharPhotoService(payload)
  .subscribe((data) => {
     console.log(data,"=========>");
    this.isLoading = false;
    if(data.status === 'SUCCESS') {
      this.successToast("Applicant Aadhar Photo Changed Successfully");
      window.location.reload();
      this.fetchSelfAadharDetails();
      this.fetchAadharBackPhoto();
      console.log("this.aadharFrontPhoto**AftrApiCall**", this.aadharFrontPhoto);
      console.log("this.aadharBackPhoto**AftrApiCall**", this.aadharBackPhoto);
    }
    else {
      this.errorToast(data.errorMessage); 
    }
  }, error => {
    this.isLoading = false;
    this.exportImportService.errorToast("Please enter valid application no.");
  });

}





  toggle(updateAdharPhotoBtn:any){
      this.isAadharPhotoEnable = updateAdharPhotoBtn.checked;
  }


  // onFileSelect(type, event) {
  //   console.log("type++++",type);
    
  //   this.submitDisabled = true;
  //   let selectedFile = event.target.files[0];
  //   const reader = new FileReader();
  //   if ( type==="FRONT" && !selectedFile) {
  //     this.errorMessage = 'Please select a file.';
  //     return;
  //   }else{
  //     this.errorMessage = 'Please select a file.';
  //   }

  

  //   reader.readAsDataURL(selectedFile);
  //   reader.onload = () => {
  //     if(type==="FRONT"){
  //       this.selectedFileName = selectedFile.name;
  //       this.aadharFrontSelectedFile = reader.result;
  //     }else{
  //       this.selectedFileName = selectedFile.name;
  //       this.aadharBackSelectedFile = reader.result;
  //     }
     
  //   };
  // }

  validateInput(event: any): void {

    const input = event.key;
    const isNumeric = /^[0-9]*$/.test(input);
    const isBackspaceOrDelete = event.code === 'Backspace' || event.code === 'Delete';
  
    // if (!isNumeric && !isBackspaceOrDelete) {
    //   event.preventDefault();
    // }
  }
  

  onFileSelectFrontPhoto(event) {    
    this.submitDisabled = true;
    let selectedFileFrontPhoto = event.target.files[0];
    if (!selectedFileFrontPhoto) {
        this.errorMessage = 'Please select a file.';
        return;
    }
    if (!selectedFileFrontPhoto.type.startsWith('image/jpeg')) {
      this.errorMessegeFrontPhoto = 'Please select a JPG image file only.';
      return;
  }
    this.selectedFileFrontPhotoName = selectedFileFrontPhoto.name;
    const reader = new FileReader();
    reader.readAsDataURL(selectedFileFrontPhoto);
    reader.onload = () => {
        this.aadharFrontPhoto = reader.result;
        this.errorMessegeFrontPhoto = '';
    };
}

onFileSelectBackPhoto(event) {    
  this.submitDisabled = true;
  let selectedFileBackPhoto = event.target.files[0];
  if (!selectedFileBackPhoto) {
      this.errorMessage = 'Please select a file.';
      return;
  }
  if (!selectedFileBackPhoto.type.startsWith('image/jpeg')) {
    this.errorMessegeBackPhoto = 'Please select a JPG image file only.';
    return;
}
  this.selectedFileBackPhotoName = selectedFileBackPhoto.name;
  const reader = new FileReader();
  reader.readAsDataURL(selectedFileBackPhoto);
  reader.onload = () => {
      this.aadharBackPhoto = reader.result;
      this.errorMessegeBackPhoto = '';
  };
}


validateRemark() {
  if (!this.remark || this.remark.trim() === '') {
    this.errorMessage = 'Remark is required.';
  } else {
    this.errorMessage = ''; // Clear error message if remark is provided
  }
}

checkInputValue(event: any) {
  console.log("Application No ****", event.target.value);
  // this.validateInput(event);
  const input = event.target.value;
  const isNumeric = /^[0-9]*$/.test(input);
  const isBackspaceOrDelete = event.code === 'Backspace' || event.code === 'Delete';
  if (event.target.value === '') {
    location.reload();
  }
}

}